'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Ads actions
/**
 * Action type for registering an ad slot
 * @type {string}
 */
var REGISTER_SLOT = exports.REGISTER_SLOT = 'REGISTER_SLOT';

/**
 * Action type for defining an ad slot
 * @type {string}
 */
var DEFINE_SLOT = exports.DEFINE_SLOT = 'DEFINE_SLOT';

/**
 * Action type for display ads on a slot
 * @type {string}
 */
var DISPLAY_AD = exports.DISPLAY_AD = 'DISPLAY_AD';

/**
 * Action type for displaying above the fold ads
 * @type {string}
 */
var DISPLAY_ADS_ABOVE_THE_FOLD = exports.DISPLAY_ADS_ABOVE_THE_FOLD = 'DISPLAY_ADS_ABOVE_THE_FOLD';

/**
 * Action type for increasing ad calls sequence
 * @type {string}
 */
var INCREASE_SEQUENCE = exports.INCREASE_SEQUENCE = 'INCREASE_SEQUENCE';

/**
 * Action type for native ad call to avoid multiple ads in single page
 * @type {string}
 */
var SET_NATIVE = exports.SET_NATIVE = 'SET_NATIVE';

/**
 * Action type for defining global ad settings
 * @type {string}
 */
var ADD_SETTINGS = exports.ADD_SETTINGS = 'ADD_SETTINGS';

/**
 * Action type for defining running environment
 * @type {string}
 */
var ADD_ENV = exports.ADD_ENV = 'ADD_ENV';

/**
 * Action type for defining request parameters
 * @type {string}
 */
var ADD_REQUEST_PARAMS = exports.ADD_REQUEST_PARAMS = 'ADD_REQUEST_PARAMS';

/**
 * Action type for content type
 * @type {string}
 */
var ADD_CONTENT_TYPE = exports.ADD_CONTENT_TYPE = 'ADD_CONTENT_TYPE';

// Page state actions
/**
 * Action type for setting page data
 * @type {string}
 */
var SET_PAGE_DATA = exports.SET_PAGE_DATA = 'SET_PAGE_DATA';


//////////////////
// WEBPACK FOOTER
// ./~/@univision/fe-commons/dist/store/actions/action-types.js
// module id = 39
// module chunks = 35783957827783 71851226274881